import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
var baseUrl = process.env.VUE_APP_BASE_URL;
export default {
  name: 'jasbwgDetail',
  data() {
    return {
      detail: {}
    };
  },
  methods: {
    getDetail() {
      let classifies = [{
        id: this.$route.query.cid
      }];
      let index = parseInt(this.$route.query.index) + 1;
      let data = encodeURIComponent(`${JSON.stringify(classifies)}`);
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/appIds-data?appIds=${this.$route.query.appIds ? this.$route.query.appIds : 1556675}&pageId=${this.$route.query.pageId ? this.$route.query.pageId : 300085}&wfwfid=${this.$route.query.wfwid || 44672}&pageSize=${index}${this.$route.query.pageId ? '' : `&classifies=${data}`}`).then(res => {
        let results = res.data.data.results;
        results = results[results.length - 1];
        this.detail = {
          name: results.fields[1].value,
          img: results.fields[0].value
        };
        this.getDetailById(results.id);
      });
    },
    getDetailByClass() {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/classifies?appIds=${this.$route.query.cids}&pageId=${this.$route.query.pageId}&wfwfid=${this.$route.query.wfwfid}`).then(res => {
        let datas = res.data.data.classifies.map(item => {
          return {
            name: item.name,
            cid: item.id,
            url: item.url,
            content: item.introduction,
            showType: item.showType
          };
        });
        console.log(datas);
        this.detail = datas.filter(d => {
          return d.cid == this.$route.query.cid;
        });
        this.detail = this.detail[0] || {};
        console.log(this.detail);
      });
    },
    getDetailById(id) {
      this.$ajax(`${baseUrl}/api/micro-backend/front/mh/detail?id=${id}`).then(res => {
        this.detail.content = res.data.data.content;
      });
    }
  },
  created() {
    document.title = this.$route.query.pageId == 412309 || this.$route.query.pageId == 1505906 ? '金坛博物馆' : '吉安数字博物馆';
    if (this.$route.query.classData) return this.getDetailByClass();
    this.getDetail();
  },
  computed: {}
};